var trackAPIConversion = function (label, eventID, fbp, fbc, timestamp, em, ph)
{
  if (typeof fbc == 'undefined') {
    fbc = null;
  }

  console.log('trackAPIConversion', label, eventID, fbp, fbc, timestamp, em, ph);
  var requestUrl = url__tracking_pixel;
  var params = 'event_name='+label + '&';
  params = params + 'event_id='+eventID + '&';
  params = params + 'fbp='+fbp + '&';
  params = params + 'fbc='+fbc + '&';
  params = params + 'timestamp='+timestamp + '&';
  params = params + 'host='+(window.location.protocol + "//" + window.location.host) + '&';
  params = params + 'em='+encodeURI(em).replace('+', '%2B') + '&';
  params = params + 'ph='+encodeURI(ph).replace('+', '%2B');
  // console.log(params);

  var xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function() {
    if (this.readyState == 4 && this.status == 200) {
      // Typical action to be performed when the document is ready:
      // document.getElementById("demo").innerHTML = xhttp.responseText;
    }
  };
  xhttp.open("POST", requestUrl, true);
  xhttp.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
  xhttp.send(params);
};

function fbq_track(label) {
  console.log('fbq_track', label);
  if (label) {
    var now = Math.floor(Date.now() / 1000);
    var eventID = uniqueId(now);
    if (typeof fbq == 'function') {
      fbq('track', label, {}, {eventID: eventID});
      trackAPIConversion(label, eventID, getCookie('_fbp'), getCookie('_fbc'), now);
    }
  }
}

function fbq_trackCustom(label) {
  console.log('fbq_trackCustom', label);
  if (label) {
    var now = Math.floor(Date.now() / 1000);
    var eventID = uniqueId(now);
    if (typeof fbq == 'function') {
      fbq('trackCustom', label, {}, {eventID: eventID});
      trackAPIConversion(label, eventID, getCookie('_fbp'), getCookie('_fbc'), now);
    }
  }
}

function trackAPIConversion__PageView(counter, em, ph) {
  console.log('trackAPIConversion__PageView');
  // console.log('trackAPIConversion__PageView', counter);
  if (typeof pixel_PageView__now == 'undefined') {
    var pixel_PageView__now = Math.floor(Date.now() / 1000);
  }
  if (typeof pixel_PageView__eventID != 'undefined' && getCookie('_fbp')) {
    trackAPIConversion('PageView', pixel_PageView__eventID, getCookie('_fbp'), getCookie('_fbc'), pixel_PageView__now, em, ph);
  } else if (counter < 20) { // 10s + 1s
    setTimeout(function () {
      trackAPIConversion__PageView(counter + 1, em, ph);
    }, 500);
  }
}
// setTimeout(function () {
//   trackAPIConversion__PageView(0, pixel_em, pixel_ph);
// }, 2000);